<template>
  <div class="fixed top-0 left-0 w-full z-[9999] h-[70px] cursor-pointer bg-white border-b border-gray-100 print:hidden">
    <div class="container-fluid px-2 md:px-4">
      <div class="flex items-center h-[70px]">
        <!-- Logo -->
        <div class="flex items-center justify-center lg:justify-start flex-1 lg:flex-none w-auto lg:w-auto xl:w-auto order-2 lg:order-1">
          <div class="header-contact">
            <div class="call-us">
                <NuxtLinkLocale :to="{ path: '/' }" aria-label="Logo" class="group inline-flex items-center">
                  <span
                    class="relative inline-block h-[71px] origin-left transition-transform duration-200"
                    :class="y > 100 ? 'scale-50' : 'scale-75 lg:scale-100'"
                  >

                    <!-- Base logo -->
                    <img
                      class="h-[71px] w-auto rotate-[5deg] opacity-100 transition-all duration-200 ease-out group-hover:opacity-0"
                      alt="cld logo"
                      src="~~/assets/cld-logo.svg"
                      width="107"
                      height="71"
                    />

                    <!-- Hover logo overlay (slightly larger) -->
                    <img
                      class="cld-logo-hover absolute left-1/2 top-1/2 h-[71px] w-auto -translate-x-1/2 -translate-y-1/2 rotate-[5deg] opacity-0 transition-all duration-200 ease-out transform scale-105 group-hover:opacity-100 group-hover:scale-110 group-hover:drop-shadow-[0_2px_10px_rgba(212,175,55,0.35)]"
                      alt="cld logo gold"
                      src="~~/assets/cld-logo.svg"
                      width="127"
                      height="71"
                    />

                    <!-- Shimmer sweep overlay -->
                    <span aria-hidden="true" class="cld-logo-shimmer pointer-events-none absolute inset-0 overflow-hidden">
                      <span
                        class="absolute -inset-y-3 -left-1/2 w-1/2 rotate-12 bg-gradient-to-r from-transparent via-white/60 to-transparent blur-sm opacity-0 mix-blend-overlay transition-all duration-200 ease-out group-hover:opacity-100 group-hover:translate-x-[240%] translate-x-[-160%]"
                      ></span>
                    </span>
                  </span>
                </NuxtLinkLocale>
            </div>
          </div>
        </div>
        
        <!-- Navigation Menu -->
        <div class="flex items-center justify-start w-auto lg:w-auto lg:flex-1 order-1 lg:order-2">
          <div class="main-menu w-fit flex items-center">
            <div class="menu-left w-fit flex items-center">
              <Nav />
            </div>
          </div>
        </div>

        <!-- Header Widgets (Account, Cart, Language) -->
        <div class="flex items-center justify-end w-auto lg:w-auto order-3">
           <!-- Lazy + flag-gated: the bell pulls in @microsoft/signalr, and the hub is
                off unless NOTIFICATIONS_ENABLED=true, so when it is off the chunk is
                never fetched at all. -->
           <ClientOnly>
             <LazyRealtimeNotificationBell v-if="notificationsEnabled" />
           </ClientOnly>
           <HeaderWidgets />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import Nav from "../widgets/navbar.vue";
import HeaderWidgets from "../widgets/header-widgets.vue";

import { useWindowScroll } from '@vueuse/core'

const router = useRouter();

const { y } = useWindowScroll()

// Mirrors runtimeConfig.public.notificationsEnabled — see the bell in the template.
const notificationsEnabled = useRuntimeConfig().public.notificationsEnabled
</script>
<style>
/* Keep minimal legacy styles for transition effects */

.flagicon {
  cursor: pointer;
  margin: 1px;
  height: 23px;
  width: 23px;
}

@media print {
  .print\\:hidden {
    display: none !important;
  }
}
</style>
